import React from 'react';

import { TFunction, useTranslation } from '@lyearn/i18n';
import { Image, MoreHoriz, Move, Trash2Outline } from '@lyearn/icons';
import { ActionMenu, ActionMenuProps } from '@lyearn/molecules';
import { DeprecatedIconButton } from '@lyearn/ui';

export enum BannerMenuActionTypes {
  Reposition = 'REPOSITION',
  Replace = 'REPLACE',
  Remove = 'REMOVE',
}

const OVERRIDES: ActionMenuProps['overrides'] = {
  PopoverContent: {
    classes: { Popover: { shadow: 'shadow-02' } },
  },
  PopoverButton: {
    classes: {
      root: 'z-10 absolute top-12 end-12 opacity-0 group-hover:opacity-100 ease-in transition',
      open: 'opacity-100',
    },
  },
};

const getMenuItems = (t: TFunction, canRemoveBanner: boolean) => [
  {
    id: BannerMenuActionTypes.Reposition,
    label: t('Course:Lesson.Reposition'),
    EndIcon: Move,
  },
  {
    id: BannerMenuActionTypes.Replace,
    label: t('Common:Actions.Replace'),
    EndIcon: Image,
  },
  { type: 'divider', enabled: canRemoveBanner },
  {
    id: BannerMenuActionTypes.Remove,
    label: t('Common:Actions.Remove'),
    appearance: 'danger',
    EndIcon: Trash2Outline,
    enabled: canRemoveBanner,
  },
];

const BannerMenu: React.FC<{ onAction: (value: string) => void; canRemoveBanner: boolean }> = ({
  canRemoveBanner,
  onAction,
}) => {
  const { t } = useTranslation();
  const items = getMenuItems(t, canRemoveBanner) as ActionMenuProps['items'];

  return (
    <ActionMenu items={items} overrides={OVERRIDES} onAction={onAction}>
      <DeprecatedIconButton
        appearance="inverse"
        className="shadow-01"
        size="small"
        variant="filled">
        <MoreHoriz />
      </DeprecatedIconButton>
    </ActionMenu>
  );
};

export default BannerMenu;
